import React, { useState } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { MdEdit } from 'react-icons/md';
import { CategoryLevels } from '../lib';
import styles from './CategoryLevel.module.scss';
import { ModalCategoryLevels } from './ModalCategoryLevels';

interface CategoryLevelProps {
  form: UseFormReturn<CategoryLevels>;
  index: number;
}
export const CategoryLevel = ({ form, index }: CategoryLevelProps) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Controller
        control={form.control}
        name={`categoryLevels.${index}`}
        render={({ field: { value, ...field }, fieldState: { error } }) => {
          return (
            <>
              <div className={styles['category-level']}>
                <div className={styles['main-content']}>
                  <span>{`Nível ${index + 1}`}</span>
                  <div>
                    <span>{value?.name}</span>
                    <button type="button" onClick={() => setOpenModal(true)}>
                      <MdEdit size={20} color="#959595" />
                    </button>
                    <ModalCategoryLevels open={openModal} onChange={field.onChange} onClose={() => setOpenModal(false)} value={value} />
                  </div>
                </div>
              </div>
              <span className={styles.error}>{error?.message}</span>
            </>
          );
        }}
      />
    </>
  );
};
